<template>

    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{name:'configuracion-carta'}">  {{$t('configuracionCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{$t('formasDePagoCarta')}}
                        </li>
                    </ol>
                </nav>
            </div>


            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-5">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{$t("negocio")}}</strong></label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           @change="permisoCarta()"
                                           :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--TABLA DE GESTION DE CONFIGURACION DE FORMAS DE PAGO-->

            <template v-if="permiso===1">

            </template>
            <template v-else-if="permiso && respuesta">

                <div class="col-md-5">
                    <div class="form-group">

                        <router-link :to="{name:'forma-de-pago-carta',params: {idBusiness:idBusiness}}">
                            <button class="btn btn-primary"><i
                                    class="fa fa-plus-square"></i>
                                {{$t('agregarFormaDePago')}}
                            </button>
                        </router-link>

                    </div>
                </div>

                <div class="col-md-7 text-right">
                    <div class="input-group">
                        <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                               v-model="searchQuery"
                               @keyup.enter.prevent="searchFormaPagoCarta()">
                        <div class="input-group-append">
                            <button class="btn btn-secondary" type="button" @click="searchFormaPagoCarta()"><i
                                    class="fa fa-search"></i>
                            </button>
                            <button class="btn btn-secondary" type="button" @click="removeFormasPagoCarta()"><i
                                    class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">

                    <div class=" table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t('nombre')}}</th>
                                <th width="20%">{{$t('acciones')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in listFormasPagoCarta">
                                <td>
                                    <div>{{obj.nombre}}

                                        <span style="color: red" v-if="obj.baja">
                                            {{$t("bajaConBrackets")}}
                                        </span>

                                    </div>
                                </td>
                                <td align="center">

                                    <div class="btn btn-warning btn-link btn-xs">
                                        <router-link
                                                :to="{name:'forma-de-pago-carta',params: {idBusiness:idBusiness,idFormaPago:obj.id} }">

                                            <i style="color: orange" v-tooltip.top-center="$i18n.t('editar')"
                                               class="fas fa-pencil-alt"
                                            ></i>
                                        </router-link>
                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>


            </template>
            <template v-if="!permiso">
                <div class="col-md-12">
                    <div class=" alert alert-primary" align="center">
                        <h3><i class="fas fa-exclamation-circle"></i> {{$t('esteNegocioNoTieneAccesoAEsteModulo')}}.</h3>

                        <span> {{$t('paraMasInformacionContacteConSu')}} <strong>{{$t('distribuidor')}}</strong>.</span>

                    </div>
                </div>

            </template>

        </div>

    </div>

</template>

<script>

    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        name: "FormasPagoCarta",
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
            [Option.name]: Option
        },
        data() {
            return {

                searchQuery: "",
                listFormasPagoCarta: [],

                //NEGOCIOS
                listBusinesses: [],
                idBusiness: 0,

                permiso: 1,

                respuesta:false,

            }
        },
        created(){

            this.$store.dispatch('setNameRoute', 'Formas de pago carta');
            this.getBusiness();
        },
        methods:{

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;

                        vm.permisoCarta();


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            permisoCarta() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'delivery/getPermisoCarta', config)
                    .then(function (response) {
                        if (response.data.response) {

                            if (response.data.result.permiso) {

                                vm.permiso = response.data.result.permiso;
                                vm.getFormasPagoCarta();

                            } else {

                                vm.permiso = response.data.result.permiso;
                            }


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });

            },

            searchFormaPagoCarta() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        query: this.searchQuery
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "delivery/searchFormasPagoCarta", config)
                    .then(function (response) {
                        if (response.data.response) {


                            vm.listFormasPagoCarta = response.data.result;

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            removeFormasPagoCarta() {

                this.getFormasPagoCarta();
            },

            getFormasPagoCarta() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "delivery/getFormasPagoCarta", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.listFormasPagoCarta = response.data.result;
                            vm.respuesta=true;
                        }else{
                            vm.respuesta=false;
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }
</script>

<style scoped>

    .card {
        padding: 20px;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/FormasPago/FormasPagoCarta.vue